import React, { useMemo, useEffect, useState, memo } from 'react'
import { useSelector } from 'react-redux'

import styled from 'styled-components'
import { useToasts } from 'react-toast-notifications'
import moment from 'moment'

import axiosInstance from '../../../../../services/config/AxiosIntance'

import TableRolesDisplay from '../../components/TableRolesDisplay'
import Loader from '../../../../../components/Loader'
import Flex from '../../../../../components/layouts/Flex'
import DashboardItemTitle from '../../components/DashboardItemTitle'
import NoData from '../../components/NoData'

import CSVDownloader from '../../../../../lib/CSVDownloader'

const RecruitersAssignedRolesAndStage = () => {
  const { addToast } = useToasts()

  const filters = useSelector((state) => state.dashboard.filters)

  const [totalPage, setTotalPage] = useState(1)
  const [currentPage, setCurrentPage] = useState(1)
  const [pageSize, setPageSize] = useState(10)
  const [rowCount, setRowCount] = useState(0)

  const [loading, setLoading] = useState(false)
  const [tableData, setTableData] = useState([])

  useEffect(() => {
    fetchData()
  }, [filters, currentPage, pageSize])

  const fetchData = async () => {
    try {
      setLoading(true)

      const queryFilter = {
        dates: filters.dates.toString(),
        recruiter_id: filters.recruiter_id,
        job_id: filters.job_id,
        company_id: filters.company_id,
        channel_id: filters.channel_id,
        stage_id: filters.stage_id
      }
      const queryParams = new URLSearchParams(queryFilter).toString()
      const fetchedPageUrl = `/job/recruiters-roles-current-stage/fetchPage?${queryParams}&pageNumber=${currentPage || 1}&pageSize=${pageSize}`

      const result = await axiosInstance.get(fetchedPageUrl)

      setTableData(result?.data?.data?.data)

      setTotalPage(result?.data?.data?.pagination?.pageCount)
      setRowCount(result?.data?.data?.pagination?.rowCount)
      setCurrentPage(result?.data?.data?.pagination?.page)
      setPageSize(result?.data?.data?.pagination?.pageSize)
    } catch (error) {
      addToast('Something went wrong', {
        appearance: 'error',
        autoDismiss: true,
      })
    } finally {
      setLoading(false)
    }
  }

  const handleExport = async () => {
    try {
      const queryFilter = {
        dates: filters.dates.toString(),
        recruiter_id: filters.recruiter_id,
        job_id: filters.job_id,
        company_id: filters.company_id,
        channel_id: filters.channel_id,
        stage_id: filters.stage_id
      }
      const queryParams = new URLSearchParams(queryFilter).toString()
      const url = `/job/recruiters-roles-current-stage/fetchAll?${queryParams}&pageNumber=${currentPage}&pageSize=${pageSize}`
      const result = await axiosInstance.get(url)

      const response = result?.data?.data?.data.map((e) => ({
        Recruiter: e.recruiter_name,
        Client: e.client,
        Role: e.role,
        Status: e.jobStatusTag,
        Initiation_date: moment(e.initiation_date).format('MM/DD/YYYY'),
        Total_aging_days: e.total_aging_days,
        Stage_this_week: e.current_week_stage,
        Stage_previous_week: e.prev_week_stage,
      }))
      CSVDownloader.downloadUnparsedCSV(response, 'Recruiters_Assigned_Roles.csv')
    } catch (error) {
      addToast('Something went wrong', {
        appearance: 'error',
        autoDismiss: true,
      })
    }
  }

  const tableColumns = useMemo(
    () => [
      {
        Header: 'Recruiter',
        accessor: 'recruiter_name',
      },
      {
        Header: 'Role',
        accessor: 'jobTitle',
      },
      {
        Header: 'Client',
        accessor: 'client',
      },
      {
        Header: 'Status',
        accessor: 'jobStatusTag',
      },
      {
        Header: 'Job Posting Date',
        accessor: 'jobPostingDate',
        Cell: ({ value }) => (value ? moment(value).format('MM/DD/YYYY') : ''),
      },
      {
        Header: 'Initiation date',
        accessor: 'jobInitiationDate',
        Cell: ({ value }) => (value ? moment(value).format('MM/DD/YYYY') : ''),
      },
      {
        Header: 'Total Aging Days',
        accessor: 'total_aging_days',
      },
      {
        Header: 'Stage of this week',
        accessor: 'current_week_stage',
      },
      {
        Header: 'Stage of previous week',
        accessor: 'prev_week_stage',
      },
      {
        Header: 'Applicant',
        accessor: 'applicantName',
      },
    ],
    []
  )

  return (
    <StyledRecruiterRoles>
      <Flex justify="space-between">
        <DashboardItemTitle title="Recruiter Assigned Roles" />
        <Flex gap="0.5rem">
          <ExportButton onClick={handleExport}>Export</ExportButton>
        </Flex>
      </Flex>

      {loading && <Loader />}

      {tableData?.length > 0 ? (
        <TableRolesDisplay
          height="100%"
          totalPage={totalPage}
          currentPage={currentPage}
          pageSize={pageSize}
          rowCount={rowCount}
          data={tableData}
          columns={tableColumns}
          setNewPageSize={setPageSize}
          setCurrentPage={setCurrentPage}
          fetchData={fetchData}
          onClick={() => null}
        ></TableRolesDisplay>
      ) : (
        <NoData />
      )}
    </StyledRecruiterRoles>
  )
}

export default memo(RecruitersAssignedRolesAndStage)

const StyledRecruiterRoles = styled.div`
  width: 100%;
  height: 100%;
`
const ExportButton = styled.button`
  padding: 0.35rem 0.65rem;
  font-size: 0.75rem;
  font-weight: 500;
  text-transform: uppercase;
  text-overflow: ellipsis;
  overflow: hidden;
  background-color: black;
  color: white;
  border-radius: 100px;
  word-spacing: 3px;
`
